import React, { useMemo } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Divider,
} from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import moment from "moment";
import { lightTable } from "../../../styles/muiProps";
import PortalHeader from "../Components/PortalHeader";
import { InfoCard } from "../Components/InfoCard";
import DownloadAsPDFBtn from "../../../components/btns/DownloadAsPDFBtn";
import DownloadablePage from "../../../components/DownloadablePage";

const DashboardPage = ({ data }) => {
  // Table columns

  const columns = useMemo(
    () => [
      {
        header: "Description",
        accessorKey: "desc",
        Cell: ({ row }) => {
          return (
            row.original.mrqMaterial?.description ||
            row.original.description ||
            "-"
          );
        },
      },
      {
        header: "Procured Qty",
        accessorKey: "qty",
        Cell: ({ row }) => {
          return (
            row.original.mrqMaterial?.procuredQty ||
            row.original.quantity ||
            "-"
          );
        },
      },
      {
        header: "Unit",
        accessorKey: "procuredUnit",
        Cell: ({ row }) => {
          return row.original.mrqMaterial?.procuredUnit || "-";
        },
      },
      {
        header: "Cost/Unit",
        accessorKey: "cost",
      },
      {
        header: "Total Cost",
        accessorKey: "totalCost",
        Cell: ({ row }) => {
          const cost = row.original.cost || 0;
          const qty =
            row.original.mrqMaterial?.procuredQty || row.original.quantity || 0;
          return cost && qty ? `$ ${cost * qty}` : "-";
        },
      },
      {
        header: "Delivery Date",
        accessorKey: "date",
        Cell: ({ row }) => {
          return `in ${row.original.time} days`;
        },
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    data: data?.poMaterials || [],
    columns,
    ...lightTable,
  });

  console.log({ data });

  const mrqData = {
    "MRQ Number": data?.mrq?.mrqNumber,
    "MRQ Revision": data?.mrq?.rev,
    "MRQ Title": data?.mrq?.title,
    "Issued At": moment(data?.mrq?.createdAt).format("YYYY-MM-DD"),
  };

  const poData = {
    "Company Name": "ChinookDT",
    "PO Number": data?.poNumber,
    "PO Revision": data?.revision,
    "PO Title": data?.title,
    "Issued At": moment(data?.createdAt).format("YYYY-MM-DD"),
  };

  return (
    <DownloadablePage
      fileName={data?.poNumber + "_Rev-" + data?.revision + ".pdf"}
    >
      <Box sx={{ p: 4 }}>
        <PortalHeader
          logo="/image/chinook_blue-logo-only.png"
          title={
            data?.poNumber ? data?.poNumber + " / Rev: " + data?.revision : ""
          }
          date={data?.createdAt}
        />
        {/* Cards Section */}
        <Grid container spacing={3} mb={4}>
          <Grid item xs={12} md={6}>
            <InfoCard title="Assigned PO Details" data={poData} />
          </Grid>

          <Grid item xs={12} md={6}>
            <InfoCard title="Related MRQ Details" data={mrqData} />
          </Grid>
        </Grid>

        {/* Table Section */}
        <Card elevation={2} sx={{ borderRadius: 3 }}>
          <CardContent>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Attached Materials
            </Typography>
            <Divider sx={{ mb: 3 }} />
            <MaterialReactTable table={table} />{" "}
          </CardContent>
        </Card>

        <Card elevation={2} sx={{ borderRadius: 3, mt: 4 }}>
          <CardContent>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              Payment Terms
            </Typography>
            <Divider sx={{ mb: 3 }} />
          </CardContent>
        </Card>
      </Box>
    </DownloadablePage>
  );
};

export default DashboardPage;
